export const CATEGORIES = {
  PRODUCTIVITY: 'productivity',
  WELLNESS: 'wellness',
  GROWTH: 'growth',
  FINANCE: 'finance',
  SOCIAL: 'social'
};

export const INTERESTS = {
  [CATEGORIES.PRODUCTIVITY]: [
    'Time Management',
    'Goal Setting',
    'Project Planning',
    'Task Organization',
    'Focus Techniques'
  ],
  [CATEGORIES.WELLNESS]: [
    'Meditation',
    'Exercise',
    'Nutrition',
    'Sleep',
    'Mental Health'
  ],
  [CATEGORIES.GROWTH]: [
    'Reading',
    'Learning',
    'Career Development',
    'Skills Acquisition',
    'Personal Development'
  ],
  [CATEGORIES.FINANCE]: [
    'Budgeting',
    'Investing',
    'Saving',
    'Debt Management',
    'Financial Planning'
  ],
  [CATEGORIES.SOCIAL]: [
    'Networking',
    'Relationship Building',
    'Community Engagement',
    'Communication',
    'Social Skills'
  ]
};

export const ONBOARDING_STEPS = {
  WELCOME: 'welcome',
  PROFILE: 'profile',
  INTERESTS: 'interests',
  GOALS: 'goals',
  PREFERENCES: 'preferences',
  PRICING: 'pricing',
  COMPLETE: 'complete'
}; 